export const faqs = [
  {
    q: '糖心吃瓜只发甜甜的内容吗？',
    a: '是的。糖心吃瓜只磕甜向小瓜，恋爱小料、心动瞬间、官宣现场与情侣小事是我们的四大板块，刻意避开让人心里发闷的料，只想让你刷完嘴角上扬。',
  },
  {
    q: '这里的瓜料来源可靠吗？',
    a: '站内内容均来自公开渠道的整理与二次创作，我们会在每篇瓜料里标注整理时间与来源标签。若涉及当事人希望撤下的内容，可来信告知，我们会第一时间处理。',
  },
  {
    q: '多久更新一次新瓜？',
    a: '编辑组工作日上午会集中上新，遇到热度高的官宣现场和心动瞬间会随时加更，瓜田速递页面能看到全部最新补充。',
  },
  {
    q: '可以投稿自己的甜味瓜吗？',
    a: '当然可以。我们欢迎真实、温暖、不涉及隐私细节的恋爱小事投稿。把你和 TA 的小片段写下来发到我们的邮箱，被选中的故事会署名或匿名发布。',
  },
  {
    q: '订阅甜瓜日报会收到什么？',
    a: '每天一封邮件，只精选当天最甜的三条瓜料加一句小感想，不推送广告，也不会把你的邮箱分享给任何第三方，随时可以退订。',
  },
  {
    q: '如何在站内快速找到想看的内容？',
    a: '可以进入瓜田速递使用分类标签筛选，也可以使用顶部搜索框按关键词查找。每篇瓜料底部的相关推荐会顺着甜度帮你继续往下看。',
  },
];

export default faqs;